"use strict";
/**
 * Core types for the backgammon game, shared between client and server.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=index.js.map